// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"141":"a9ee0206","870":"a9ee0206"}[chunkId] + ".css";
};